import axios from 'axios';
import { history } from '../Router/createHistory';
import { getRefreshToken } from '../Pages/Login/Login.saga';
import { store } from '../App';

const defaultParamsObj = {
  method: 'get',
  data: false,
  withAuth: false,
  customHeader: {},
};

export default function request(url, params = defaultParamsObj) {
  const { method, data, customHeader, responseType, remember, action } = params;
  const requestBody = {
    method,
    url,
  };
  const headers = {
    ...customHeader,
    'Access-Control-Allow-Origin': true,
    Authorization:
      localStorage.getItem('token') || sessionStorage.getItem('token'),
    'refresh-token':
      localStorage.getItem('refreshToken') ||
      sessionStorage.getItem('refreshToken'),
    'Accept-Language': localStorage.getItem('language') || 'en_IN',
  };
  requestBody.headers = headers;
  if (data && method) {
    requestBody.method = method;
    requestBody.data = data;
  } else if (data) {
    requestBody.method = 'POST';
    requestBody.data = data;
  } else if (method) {
    requestBody.method = method;
  } else {
    requestBody.method = 'GET';
  }
  if (responseType) requestBody.responseType = responseType;

  return axios({
    ...requestBody,
  })
    .then((response) => {
      if (response.headers && response.headers.authorization) {
        if (remember) {
          localStorage.setItem('token', response.headers.authorization);
          if (response.headers['refresh-token']) {
            localStorage.setItem(
              'refreshToken',
              response.headers['refresh-token']
            );
          }
        } else {
          sessionStorage.setItem('token', response.headers.authorization);
          if (response.headers['refresh-token']) {
            sessionStorage.setItem(
              'refreshToken',
              response.headers['refresh-token']
            );
          }
        }
      }
      return response.data;
    })
    .catch((error) => {
      if (
        error.response.data.status === 403 ||
        error.response.data.status === 419
      ) {
        if (history.location && history.location.pathname !== '/login') {
          localStorage.clear();
          sessionStorage.clear();
          history.push('/login');
        }
      } else if (error.response.data.status === 401) {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        store.dispatch(
          getRefreshToken({
            callback: () => {
              store.dispatch(action);
            },
          })
        );
        return {};
      } else {
        const { entity } = error.response.data;
        if (entity && Object.keys(entity).length > 0) {
          return error.response.data;
        }
      }
      throw error.response.data;
    });
}
